import React from "react";

import Vacancy from "../SearchResults/Vacancy";

function InlineDescriptiveSingleJob() {
  return <Vacancy singleJobView centerCard />;
}

export default InlineDescriptiveSingleJob;
